import ListPageHeader from "@/components/ListPageHeader";
import { ProductLogoMediumTimeAndAttendance } from "@/components/Logo";
import { NotFound } from "@/components/NotFound/NotFound";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { featureFlags } from "@/lib/env";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/time-and-attendance/_layout")({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.timeAndAttendance",
  });
  useDocumentTitle(t("pageTitle"));

  if (!featureFlags.check("NewFeature")) {
    return <NotFound />;
  }

  return (
    <div className="flex flex-col">
      <ListPageHeader
        icon={<ProductLogoMediumTimeAndAttendance />}
        title={t("pageTitle")}
        tabs={[
          {
            to: "/time-and-attendance/summary",
            children: t("tabs.attendances"),
            activeOptions: { exact: false },
          },
          {
            to: "/time-and-attendance/attendance-links",
            children: t("tabs.attendanceLinks"),
            activeOptions: { exact: false },
          },
        ]}
      />
      <Outlet />
    </div>
  );
}
